var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('BaseBlock',{attrs:{"title":"Erreur !"}},[_c('p',[_vm._v(_vm._s(_vm.message))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }